export default {
  FACEBOOK: 'https://www.facebook.com/albertdigitallearning/',
  INSTAGRAM: 'https://www.instagram.com/albert_digital_learning/',
  LINKEDIN: 'https://www.linkedin.com/company/albert-ab/',
  YOUTUBE: 'https://www.youtube.com/@albert_digital_learning',
};
